import { TrackedLinkContext } from "@faire/retailer-visitor-shared/components/TrackedLink/index";
import { PAGE_TYPE } from "@faire/retailer-visitor-shared/consts/PAGE_TYPE";
import { Category } from "@faire/retailer-visitor-shared/models/Category/Category";
import { useCategoryPageFilterKeys } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useCategoryPageBrandFirstSearchResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageBrandFirstSearchResults";
import { CategoryPageBrandGrid } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/__internal__/CategoryPageBrandGrid";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import React from "react";

export const BrandFirstResults = ({
  categoryPageLoadTimingRef,
  isLoading,
  requestId,
  headerText,
  categoryModel,
  isScrollingToTop,
  onFirstBatchVisible,
  shouldRenderExtraTileOnXLScreen,
}: {
  categoryPageLoadTimingRef: React.Ref<HTMLDivElement> | undefined;
  isLoading: boolean;
  requestId?: string;
  headerText?: string;
  categoryModel?: Category;
  isScrollingToTop?: boolean;
  onFirstBatchVisible?: () => void;
  shouldRenderExtraTileOnXLScreen?: boolean;
}) => {
  const brandFirstSearchResults = useCategoryPageBrandFirstSearchResults();
  const filterKeys = useCategoryPageFilterKeys();

  return (
    <div style={{ position: "relative" }} ref={categoryPageLoadTimingRef}>
      <TrackedLinkContext.Provider
        value={{
          type: IClickInfo.Type.BRAND,
          requestId: requestId,
          containerName: "marketplace_maker_grid",
        }}
      >
        <CategoryPageBrandGrid
          title={headerText}
          pageType={PAGE_TYPE.CATEGORY}
          isLoading={isLoading}
          category={categoryModel}
          filterKeys={filterKeys}
          searchResults={isLoading ? [] : brandFirstSearchResults}
          requestId={requestId}
          isScrollingToTop={isScrollingToTop}
          onFirstBatchVisible={onFirstBatchVisible}
          itemsPerRow={
            shouldRenderExtraTileOnXLScreen
              ? { mobileAndAbove: 2, tabletAndAbove: 4, xLargeAndAbove: 5 }
              : undefined
          }
        />
      </TrackedLinkContext.Provider>
    </div>
  );
};
